<template>
  <div class="grid grid-cols-8 items-center gap-4">
    <Label :for="id" class="col-span-2 text-right"> {{ label }} </Label>
    <div class="col-span-5">
      <Select v-model:modelValue="value" :id="id" @update:model-value="handleChange">
        <SelectTrigger class="w-full">
          <SelectValue :placeholder="placeholder" class="mr-auto ml-auto" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem v-for="option in options" :key="option.value" :value="option.value">
            {{ option.label }}
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  </div>
</template>
<script lang="ts" setup>
import type { AcceptableValue } from 'reka-ui';
import { Label } from '~/components/ui/label';
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from '~/components/ui/select';

type SelectValue = string | number;

const value = defineModel<SelectValue>({ required: true });
const props = defineProps({
  id: String,
  label: String,
  placeholder: String,
  options: {
    type: Array<{ label: string; value: SelectValue }>,
    default: () => [],
  },
});
const emit = defineEmits(['handleChange']);
const handleChange = (val: AcceptableValue) => {
  emit('handleChange', val);
};
</script>
